import { IViewData } from '@barba/core';

export default {
    namespace: 'error-page',

    beforeEnter({ next }: IViewData) {
        document.body.classList.add('fullscreen-page');
    },

    afterLeave({ current }: IViewData) {
        document.body.classList.remove('fullscreen-page');
    },
};
